"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listFirewalls = void 0;
const listFirewalls = ({ httpClient, }) => ({ page = 1, per_page = 25, }) => {
    const path = '/firewalls';
    const query_params = { page, per_page };
    const url = `${path}`;
    return httpClient.get(url, { params: query_params });
};
exports.listFirewalls = listFirewalls;
//# sourceMappingURL=list-firewalls.js.map